import React from 'react';
import ReactDOM from 'react-dom';
import Loader from "../Loader";
import { FileUpload } from 'primereact/fileupload';
import {toast, ToastContainer} from 'react-toastify';

class BaseCensoShopping extends React.Component {

    fileUploadRef;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            errors: {}
        }
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading
        });
    }

    uploadHandler = async (e) => {
        try{
            await this.setLoading(true);
            const formData = new FormData();
            formData.append('arquivo', e.files[0]);

            const response = await axios.post(route('base_censo_shopping.enviar'), formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status == 200) {
                alert('O processemanto será executado em segundo plano. Em alguns instantes os shoppings serão atualizados')
            }

        } catch (e){
            console.log(e);
        } finally {
            this.fileUploadRef.clear();
            await this.setLoading(false);
        }
    }

    render() {
        return (
            <div>
                <div className="card">
                    {this.state.loading && (
                        <Loader/>
                    )}

                    <div className="card-body">
                        <div className="card">
                            <div className="card-body">
                                <form action="">
                                    <div className="form-group row">
                                        <div className="col-12 col-md-4 col-sm-4 col-lg-4">
                                            <label htmlFor="title">Selecione o arquivo</label>
                                            <FileUpload
                                                ref={(el) => this.fileUploadRef = el}
                                                name="arquivo"
                                                mode="basic"
                                                auto
                                                accept=".xlsx"
                                                uploadLabel="Importar shoppings"
                                                chooseLabel="Importar shoppings"
                                                customUpload={true}
                                                uploadHandler={this.uploadHandler}
                                                onUpload={(e)=>{
        
                                                }}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('app-base-censo-shopping')) {
    ReactDOM.render(<BaseCensoShopping/>, document.getElementById('app-base-censo-shopping'));
}
